<form *ngIf="form" [formGroup]="form" (ngSubmit)="save()">
    <div class="modal-header">
        <h4 class="modal-title pull-left">{{ title }}</h4>
    </div>
    <div class="modal-body add-part-kit">
        <div class="form-group">
            <label class="control-label required_field">Part kit</label>
            <div class="controls">
                <input
                    id="part-kit"
                    type="text"
                    csSelect2
                    [select2Config]="select2Config"
                />
            </div>
        </div>
        <div class="form-group required p-kit-qty-b">
            <label class="control-label required_field">Quantity</label>
            <div class="controls">
                <input
                    type="number"
                    min="1"
                    class="qty-input"
                    (keypress)="blockZero($event)"
                    formControlName="quantity"
                    (input)="updateTotalParts()"
                />
            </div>
        </div>
        <div class="part-results" *ngIf="selectedKitParts.length > 0">
            <div class="part-card" *ngFor="let part of selectedKitParts">
                <span class="part-name">{{ part.partName }}</span>
                <div class="part-meta"><span *ngIf="part.manufacturePartNumber != '' && part.manufacturePartNumber != null">{{ part.manufacturePartNumber }} · </span>
                    <span class="part-qty">Qty: {{ part.totalQty }}</span>
                </div>
            </div>
        </div>
        <div *ngIf="partStatus.length > 0">
            <label for="partStatus" class="required_field label-space-top">Part status</label>
            <div class="controls tax-items">
                <input type="hidden" csSelect2 [select2Config]="select2PartStatusConfig" id="partStatus" formControlName="partStatus"
                       [placeholder]="'-- Select option --'" class="chosen-select full-width-select">
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <a href="javascript:void(0)" class="btn" (click)="bsModalRef.hide()">Cancel</a>
        <button
            #saveBtn
            [disabled]="form.invalid || action == 'saving'"
            class="btn btn-primary"
        >
            <span [hidden]="action == 'saving'">Save</span>
            <span [hidden]="action != 'saving'">Saving</span>
        </button>
    </div>
</form>
